import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import WidgetCard from '../../../../../components/card/WidgetCard';
import { Loader } from '../../../../../components/loader/SpinnerLogo';
import useFetch from '../../../../../hooks/useFetch';
import { TutorService } from '../../../../../services/tutor/tutorService';
import { fixNumber } from '../../../../../utils/formatNumber';
import TutorProfileLayout from '../../TutorProfileLayout';

interface TutorStatsProps { }

const TutorStats: React.FC<TutorStatsProps> = () => {
    const { id = '' } = useParams<{ id: string }>();

    const [data, loading] = useFetch(useCallback(async () => {
        if (!id) return null;
        const response = await (new TutorService()).getTutorProductsStats(id);
        return response.getResponseData()?.data;
    }, [id]));

    const statsCards = [
        { title: 'Productos asignados', value: data?.totalProducts ?? 0 },
        { title: 'Contratos asignados', value: data?.totalContracts ?? 0 },
        { title: 'Contratos pendientes de factura', value: data?.pendingInvoiceContracts ?? 0 },
        { title: 'Facturas generadas', value: data?.totalInvoices ?? 0 },
        { title: 'Importe facturado', value: `${fixNumber(data?.totalInvoicedAmount ?? 0)} EUR` },
    ];

    return (
        <TutorProfileLayout>
            {loading ? (
                <Loader height='50vh' />
            ) : (
                <div className='@container pt-4'>
                    <div className='grid grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3'>
                        {statsCards.map((item) => (
                            <WidgetCard key={item.title} title={item.title} className='min-h-[132px]'>
                                <div className='pt-6'>
                                    <p className='text-3xl font-semibold text-gray-900'>{item.value}</p>
                                </div>
                            </WidgetCard>
                        ))}
                    </div>
                </div>
            )}
        </TutorProfileLayout>
    );
};

export default TutorStats;
